import { instance } from "../apiBase/instance";

export const apiLaunchPad = {
    getPoolLive(page:any , limit:any) {
        return instance.get<any>(`api/campaigns?page=${page}&limit=${limit}&type=LIVE`);
    },
    getPoolUpcoming(page:any , limit:any , keySearch:any) {
        return instance.get<any>(`api/campaigns?page=${page}&limit=${limit}&type=UPCOMING&search=${keySearch}`);
    },
    getPoolEnd(page:any , limit:any , keySearch:any) {
        return instance.get<any>(`api/campaigns?page=${page}&limit=${limit}&type=END&search=${keySearch}`);
    },
    getDetailLaunchpad(slug:any) {
        return instance.get<any>(`api/campaigns/slug/${slug}`);
    },
    requestCommit(params:any) {
        return instance.post<any>(`api/commit-receipts/request-commit`,{...params});
    },
    checkWhiteList(id:any, address :any) {
        return instance.get<any>(`api/whitelists/campaign/${id}/user/${address}`);
    },
    updateHashCommit(params:any, id :any) {
        return instance.post<any>(`api/commit-receipts/update-transaction/${id}`,{...params});
    },
    getVesting(id:any, address :any) {
        return instance.get<any>(`api/vestings/pool/${id}/user/${address}`);
    },
    updateHashClaim(params:any, id :any) {
        return instance.post<any>(`/api/vestings/update-transaction/${id}`,{...params});
    },
    updateHashBonus(params:any, id :any) {
        return instance.post<any>(`/api/bonuses/update-transaction/${id}`,{...params});
    },
    updateHashRefundAll(params:any, id :any) {
        return instance.post<any>(`/api/refunds/update-transaction/${id}`,{...params});
    },
    updateHashRefundPartical(params:any, id :any) {
        return instance.post<any>(`/api/partial-refunds/update-transaction/${id}`,{...params});
    },
    getDashboard() {
        return instance.get<any>(`api/dashboards/statistic`);
    },
    updateHashClaimChange(params:any, id :any) {
        return instance.post<any>(`/api/crfs/update-transaction/${id}`,{...params});
    },
    getPoolAll(page:any , limit:any ,type:any , keySearch:any) {
        return instance.get<any>(`api/campaigns?page=${page}&limit=${limit}&type=${type}&search=${keySearch}`);
    },
    getPoolJoined(address:any ,page:any , limit:any ) {
        return instance.get<any>(`api/campaigns/joined-campaign/${address}?page=${page}&limit=${limit}`);
    },
    getPoolJoinedNew(address:any ,page:any , limit:any, search:any  ) {
        return instance.get<any>(`api/campaigns/joined-campaign/${address}?page=${page}&limit=${limit}&search=${search}`);
    },
    getPoolClaimable(address:any ,page:any , limit:any, search:any  ) {
        return instance.get<any>(`api/campaigns/claimable-campaign/${address}?page=${page}&limit=${limit}&search=${search}`);
    },
    getSolanaAddres(address:string ,campaignID: number ) {
        return instance.get<any>(`api/campaigns/${campaignID}/users/${address}`);
    },
    submitSolanaAddres(params:any) {
        return instance.post<any>(`api/campaigns/user-campaign-address`,{...params});
    },
    
}